import React from 'react';
import { useParams, useOutletContext } from 'react-router-dom';
import RosterTables from '../../components/RosterTables';

/**
 * Another team's roster page. Renders the exact same view as "My Roster"
 * (RosterTables) but in read-only mode: lineup slot buttons are disabled and the
 * drop action is hidden, while the trade action stays available and pre-targets
 * this team + player.
 */
function TeamRoster() {
  const { teamId } = useParams();
  const { league } = useOutletContext();
  const team = (league?.teams || []).find(
    (t) => String(t.id ?? t.teamId) === String(teamId)
  );

  if (!team) {
    return (
      <div className="empty-state">
        <h2>Team Not Found</h2>
      </div>
    );
  }

  return <RosterTables team={team} readOnly />;
}

export default TeamRoster;
